import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSchool: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSchool"><Path fillRule="evenodd" clipRule="evenodd" d="M6 4H18V18.5H19V8H22V18.5H23V20H1V18.5H2V8H5V18.5H6V4ZM14 18.5V15H10V18.5H14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSchool;
